import React, { useState, useEffect } from "react";
import { Container, Typography } from "@mui/material";
import styles from "./lotsHeaderBarStyles.js";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import PendingLotsTable from "../LotsPendingTable/index.js";
import AssignedLotsTable from "../LotsAssingedTable/index.js";
import { usePermissions } from "../../../hooks/permissions/usePermissions.js";

const LotsTabBar = ({ lots, collectedLots, isLoading, fetchLots, fetchCollectedLots, search, setHasItemsSelected, setSelectedLots }) => {
  
  const { hasPermission, hasAllPermissions } = usePermissions();

  const canViewLots = hasPermission("lot_vw");

  const tabs = [];
  if (canViewLots && hasPermission("vw_pel")) tabs.push("1");
  if (canViewLots && hasPermission("vw_asl")) tabs.push("2");
  
  const [value, setValue] = useState(tabs[0] || "1");
  
  // Estados de selección por pestaña
  const [selectedLotsTab1, setSelectedLotsTab1] = useState([]);
  const [selectedLotsTab2, setSelectedLotsTab2] = useState([]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    // Actualizar el estado global basado en la pestaña actual
    if (newValue === "1") {
      setSelectedLots(selectedLotsTab1);
      setHasItemsSelected(selectedLotsTab1.length > 0);
    } else if (newValue === "2") {
      setSelectedLots(selectedLotsTab2);
      setHasItemsSelected(selectedLotsTab2.length > 0);
    }
  };

  // Sincronizar el estado global cuando cambie la selección en las tablas
  useEffect(() => {
    if (value === "1") {
      setSelectedLots(selectedLotsTab1);
      setHasItemsSelected(selectedLotsTab1.length > 0);
    } else if (value === "2") {
      setSelectedLots(selectedLotsTab2);
      setHasItemsSelected(selectedLotsTab2.length > 0);
    }
  }, [selectedLotsTab1, selectedLotsTab2, value, setSelectedLots, setHasItemsSelected]);

  if (!canViewLots) {
    return (
      <Container style={styles.primaryContainer}>
        <Typography variant="body1">
          No tienes permisos para ver recolecciones
        </Typography>
      </Container>
    );
  }

  return (
    <Container style={styles.primaryContainer}>
      <TabContext value={value}>
        <Container style={styles.mainContainer}>
          <Box sx={styles.tabContainer}>
            <TabList
              onChange={handleChange}
              aria-label="lab API tabs example"
              variant="fullWidth"
            >
              {hasAllPermissions(["vw_pel", 'lot_vw']) && <Tab label="Recolecciones pendientes" value="1" />}
              {hasAllPermissions(["vw_asl", 'lot_vw']) && <Tab label="Recolecciones asignadas" value="2" />}
            </TabList>
          </Box>
        </Container>

        <Container
          style={styles.mainContainer}
          sx={{ padding: "0 !important" }}
        >
          <Box sx={{ width: "100%" }}>
            {hasAllPermissions(["vw_pel", 'lot_vw']) && (
              <TabPanel value="1">
                <PendingLotsTable
                  lots={lots}
                  isLoading={isLoading}
                  search={search}
                  fetchLots={fetchLots}
                  setHasItemsSelected={setHasItemsSelected}
                  setSelectedLots={setSelectedLotsTab1}
                  selectedLots={selectedLotsTab1}
                />
              </TabPanel>
            )}
            {hasAllPermissions(["vw_asl", 'lot_vw']) && (
              <TabPanel value="2">
                <AssignedLotsTable
                  lots={collectedLots}
                  isLoading={isLoading}
                  search={search}
                  fetchLots={fetchCollectedLots}
                  setHasItemsSelected={setHasItemsSelected}
                  setSelectedLots={setSelectedLotsTab2}
                  selectedLots={selectedLotsTab2}
                />
              </TabPanel>
            )}
          </Box>
        </Container>
      </TabContext>
    </Container>
  );
};

LotsTabBar.propTypes = {
  value: PropTypes.string,
  handleChange: PropTypes.func,
};

export default LotsTabBar;
